import React from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";

export const AboutColaHome = () => {
  return (
    <Paper elevation={3} sx={{ p: 4, mt: 4, mb: 4, backgroundColor: '#f9f9f9' }}>
      <Grid container spacing={4}>
         <Grid item xs={12} md={6}>
            <Typography variant="h4" component="h2" gutterBottom color="primary">
               About The Cola
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem' }}>
              The Cola Lounge is a private, members only space where buds can feel at home, learn and have fun while they safely enjoy the plant.
            </Typography>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              Why The Cola?
            </Typography>
            <Typography variant="body1" paragraph>
               The Cola is name for the flowering site of the plant...quite literally "Where Buds Meet" Get it?
            </Typography>
             <Typography variant="h5" gutterBottom sx={{ mt: 3, fontStyle: 'italic', color: 'secondary.main' }}>
               "WHERE BUDS MEET"
            </Typography>
         </Grid>
         <Grid item xs={12} md={6}>
            <Typography variant="h5" gutterBottom>
              Location & Hours
            </Typography>
            <Typography variant="body1" paragraph>
              <strong>2834 Cherokee Street, 63118</strong>
            </Typography>
            <Box sx={{ mt: 2, mb: 3 }}>
               <Typography variant="subtitle1" fontWeight="bold">Open by Appointment, Events & Private Bookings Only</Typography>
               <Typography variant="body2">Every 1st Sunday: Pass That Open Mic Comedy</Typography>
               <Typography variant="body2">Saturdays: Elevated Easel Paint Class</Typography>
               <Typography variant="body2">Every 3rd Monday: High Notes Karaoke</Typography>
               <Typography variant="body2">Every 3rd Friday: Best Medicine Comedy & Dinner</Typography>
            </Box>

            <Typography variant="h6" gutterBottom>
               What We Offer
            </Typography>
            <Grid container spacing={1}>
                {[
                  "💨 Budbar (pipes, vapes, wraps, papers)",
                  "🍳 Infusion Kitchen",
                  "🌄☕️ Coffee & Tea",
                  "🎧🖥️ AV production Area",
                  "🎮🕹 Video Games",
                  "♟♠️👨🏾🎨📚⚽️ Board Games, Puzzles, Coloring Books, Foosball",
                  "🍯🕯 Rosin Press",
                  "🥨🍿 Munchies",
                  "📶 💻 Strong WIFI",
                  "😎😌✌🏾💚💨 Good Vibes"
                ].map((item, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                        <Typography variant="body2">
                           {item}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
         </Grid>
      </Grid>
    </Paper>
  );
};
